<template>
  <div>
    <div class="wrapper">
      <div style="padding-left: 20px;" v-if="isShowcontent">
        <el-page-header @back="goBack" content="作品详情"> </el-page-header>
      </div>
      <el-divider v-if="isShowcontent"></el-divider>

      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-card class="box-card" shadow="never" body-style="padding:0px;">
              <el-row>
                <el-col :span="24">
                  <div class="work_img_wrapper">
                    <iframe ref="iframeSc" id="scratch" style="border: 0px; overflow: hidden" :src="
                        '/scratch/player.html?work_title=' +
                          workinfo.work_title +
                          '&work_url=' +
                          workinfo.work_url +
                          '&scale=' +
                          scale
                      " :width="frameWidth" :height="frameHeight"></iframe>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="18">
                  <div>
                    <el-row>
                      <el-col :span="6">
                        <div class="workactive">
                          <el-row>
                            <el-col :span="12">
                              <div>
                                <el-button class="work_thumb" type="danger" icon="el-icon-thumb" size="mini" :plain="!workinfo.zanState" @click="updateScWorkZanList"></el-button>
                              </div>
                            </el-col>
                            <el-col :span="12">
                              <div class="work_thumb_div">
                                <div class="work_thumb_txt">点赞</div>
                                <div class="work_thumb_num">
                                  {{ workinfo.zan }}
                                </div>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="workactive">
                          <el-row>
                            <el-col :span="12">
                              <div>
                                <el-button class="work_thumb" type="warning" icon="el-icon-star-off" size="mini" :plain="!workinfo.keepState" @click="updateScWorkKeepList"></el-button>
                              </div>
                            </el-col>
                            <el-col :span="12">
                              <div class="work_thumb_div">
                                <div class="work_thumb_txt">收藏</div>
                                <div class="work_thumb_num">
                                  {{ workinfo.keep }}
                                </div>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="workactive"></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="workactive"></div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-card>

            <el-row>
              <el-col :span="24">
                <div class="comment">
                  <el-card class="box-card" shadow="never" header="欢迎给我的作品留言" body-style="padding:0px;">
                    <communitycomment ref="communitycomment" @doSend="doSend" @doChidSend="doChidSend" @deleteSend="deleteSend" @deleteSendReplay="deleteSendReplay" :commentList="commentList" :commentNum="commentNum" :authorId="authorId" :avatar="
                        $store.state.user.userInfo.userImageUrl
                          ? $store.state.user.userInfo.userImageUrl
                          : $store.state.user.userInfo.headimgUrl
                      "></communitycomment>

                    <div style="margin: 20px; text-align: center">
                      <el-pagination @current-change="handleCurrentChange1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1">
                      </el-pagination>
                    </div>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-card class="box-card" shadow="hover" body-style="padding:2px;">
              <el-row>
                <el-col :span="24">
                  <div class="createrinfo">
                    <el-row>
                      <el-col :span="12">
                        <div class="createrinfo-left">
                          <div class="createrinfo-left-img">
                            <el-image class="left-img" :src="workinfo.headImgUrl" fit="fill"></el-image>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="createrinfo-right">
                          <div class="right-name">{{ workinfo.name }}</div>
                          <div class="right-num">
                            作品
                            <span style="margin-left: 5px">{{ total }}</span>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="worktitle">
                    <span style="font-weight: bold">名称
                      <span style="margin-left: 0px">《{{ workinfo.title }}》</span></span>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="worklooknum">
                    <span style="font-size: 12px"> 浏览量:</span><span style="margin-left: 10px">{{ workinfo.looks }}</span>次 <br />
                    <span style="font-size: 12px"> 发布于:</span><span style="margin-left: 10px">{{
                      workinfo.update_time
                    }}</span><br />
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="worktag">
                    <el-tag v-for="item of workinfo.tagList" :key="item.id" class="type" size="mini" type="warning" effect="dark">{{ item.workTagInfo.name }}</el-tag>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="wordintro">
                    <span style="font-size: 15px; font-weight: bold">
                      作品简介</span>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="intro_content">
                    {{ workinfo.abstract }}
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="wordintro">
                    <span style="font-size: 15px; font-weight: bold">
                      操作说明</span>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="intro_content">
                    {{ workinfo.explain }}
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="workcode">
                    <el-popover placement="top-start" title="手机分享" width="150" trigger="click" content="手机分享作品，赶快体验吧!">
                      <div id="qrcodeImg"></div>

                      <el-button slot="reference" size="mini" type="primary" icon="el-icon-mobile-phone" @click="WorkQrcode">用手机玩</el-button>
                    </el-popover>

                    <el-button style="margin-left: 20px" size="mini" icon="el-icon-view" type="primary" :disabled="workinfo.is_only" @click="LookCode">查看源码</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-card>

            <div class="morework_wrapper">
              <el-card class="box-card" shadow="never" body-style="padding:0px;">
                <el-row>
                  <el-col :span="24">
                    <div class="morework">Ta的作品</div>
                  </el-col>
                </el-row>

                <el-row v-for="item of workList" :key="item.id">
                  <el-col :span="12">
                    <div class="workmore_left">
                      <div class="workmore_img_wrapper">
                        <el-image @click="LookWork(item)" class="workmore_img" :src="item.covers" fit="fill"></el-image>
                      </div>
                    </div>
                  </el-col>

                  <el-col :span="12">
                    <div class="workmore_right">
                      <div class="workmore_right_title">{{ item.title }}</div>
                      <div>
                        <el-row>
                          <el-col :span="12">
                            <div class="workmore_right_num">
                              <i class="el-icon-view"></i>浏览:
                              <span style="margin-left: 5px">{{
                                item.looks
                              }}</span>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="workmore_right_num">
                              <i class="el-icon-thumb"></i>点赞:
                              <span style="margin-left: 5px">{{
                                item.zan
                              }}</span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <communityfooter></communityfooter>
  </div>
</template>

<script>
import communityfooter from './footer'
import communitycomment from './comment'

import {
  getScWorkContent,
  updateScWorkLooks,
  updateScWorkZanList,
  updateScWorkKeepList,
  getOneUserWorkList,
  addScWorkComment,
  getScWorkCommentList,
  addScWorkCommentReplay,
  deleteScWorkComment,
  deleteScWorkCommentReplay,
} from '@/api/community'

import QRCode from 'qrcodejs2' // 引入qrcode

export default {
  name: 'community-project',
  components: {
    communityfooter,
    communitycomment,
  },

  data() {
    return {
      isShowcontent: false,
      workinfo: {
        headImgUrl: '',
      },
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,
      //Ta的作品分页
      page_no: 1,
      page_size: 4,
      total: 0,
      //作品评论分页
      page_no1: 1,
      page_size1: 10,
      total1: 0,
      workList: [],
      commentList: [],
      commentNum: 0,
      authorId: 0, //作者ID
    }
  },

  created() {
    this.frameWidth = document.documentElement.clientWidth / 2 - 10
    this.frameHeight = this.frameWidth * 0.75 + 55
    this.scale = this.frameWidth / 480
  },

  mounted() {
    if (this.$route.query.path != undefined) {
      this.isShowcontent = true
    } else {
      this.isShowcontent = false
    }
    //document.getElementsByClassName("header-wrapper")[0].style.background ="#529dfe";
    //document.getElementById("home_top").style.display = "block"; //新页面无法监听路由
    console.log('SCRATCH作品详情')
    this.qrcode()
    this.getScWorkCommentList()
    this.getScWorkContent()
    this.updateScWorkLooks()

    window.scrollTo(0, 0)
  },

  methods: {
    goBack() {
      console.log('返回上一层')
      this.$router.push({
        name: this.$route.query.path,
      })
    },

    qrcode() {
      new QRCode('qrcodeImg', {
        width: 150,
        height: 150,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=1&work_id=' +
          this.$route.query.work_id +
          '&subject_code=' +
          this.$route.query.subject_code, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    WorkQrcode() {
      document.getElementById('qrcodeImg').innerHTML = ''
      console.log('生成二维码')
      this.qrcode()
      this.dialogVisible = true
    },

    getScWorkContent() {
      getScWorkContent({
        work_id: this.$route.query.work_id,
      }).then((res) => {
        console.log('查询作品详情')
        console.log(res)
        this.workinfo = res.scWork
        this.authorId = res.scWork.stu_user_id
          ? res.scWork.stu_user_id
          : res.scWork.user_id //获得作品ID

        this.getOneUserWorkList()
        console.log('父组件-作者ID')
        console.log(this.authorId)
      })
    },
    //增加作品浏览量
    updateScWorkLooks() {
      updateScWorkLooks({
        work_id: this.$route.query.work_id,
      }).then((res) => {
        console.log('增加作品浏览量')
        console.log(res)
      })
    },

    //更新点赞数
    updateScWorkZanList() {
      updateScWorkZanList({
        work_id: this.$route.query.work_id,
        operate_state: !this.workinfo.zanState ? '1' : '2',
      }).then((res) => {
        console.log('增加作品点赞数')
        console.log(res)
        if (res.is_update) {
          this.$message.success('点赞成功')
          this.workinfo.zanState = true
          this.workinfo.zan = this.workinfo.zan + 1
        }
        if (res.is_delete) {
          this.$message.warning('取消点赞')
          this.workinfo.zanState = false
          this.workinfo.zan = this.workinfo.zan - 1
        }
      })
    },

    //更新收藏
    updateScWorkKeepList() {
      updateScWorkKeepList({
        work_id: this.$route.query.work_id,
        operate_state: !this.workinfo.keepState ? '1' : '2',
      }).then((res) => {
        console.log('增加作品收藏数')
        console.log(res)
        if (res.is_update) {
          this.$message.success('收藏成功')
          this.workinfo.keepState = true
          this.workinfo.keep = this.workinfo.keep + 1
        }
        if (res.is_delete) {
          this.$message.warning('取消收藏')
          this.workinfo.keepState = false
          this.workinfo.keep = this.workinfo.keep - 1
        }
      })
    },

    //获得某个学员的作品列表
    getOneUserWorkList() {
      console.log('Ta的作品参数')
      console.log(this.$route.query.subject_code)
      console.log(this.workinfo.user_code)

      getOneUserWorkList({
        subject_code: this.$route.query.subject_code,
        user_code: this.workinfo.user_code,
        title: '',
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('Ta的作品-获得某个学员的作品列表')
        console.log(res)
        this.workList = res.workList
        this.total = res.total
      })
    },
    //根评论
    doSend(val) {
      console.log('评论组件返回的数据')
      console.log(val)
      this.addScWorkComment(val)
      console.log(this.$route.query.work_id)
    },
    //删除根评论
    deleteSend(val) {
      console.log('评论组件返回一级评论删除ID')
      console.log(val)
      this.deleteScWorkComment(val)
    },

    //子评论
    doChidSend(val1, val2, val3) {
      //val1 评论内容  val2 原评论用户id  val3 评论id
      console.log('子评论返回数据')
      console.log(val1)
      console.log(val2)
      console.log(val3)
      this.addScWorkCommentReplay(val3, val2, val1)
    },

    //删除子评论
    deleteSendReplay(val) {
      console.log('评论组件返回二级评论删除ID')
      console.log(val)
      this.deleteScWorkCommentReplay(val)
    },

    //评论作品
    addScWorkComment(content) {
      addScWorkComment({
        work_id: this.$route.query.work_id,
        content: content,
      }).then((res) => {
        console.log('评论作品')
        console.log(res)
        if (res.is_create) {
          this.$message.success('留言成功')
          this.getScWorkCommentList()
        }
      })
    },

    //添加作品评论回复
    addScWorkCommentReplay(
      sc_work_comment_id,
      sc_work_comment_replay_id,
      content
    ) {
      addScWorkCommentReplay({
        sc_work_comment_id: sc_work_comment_id,
        sc_work_comment_replay_id: sc_work_comment_replay_id
          ? sc_work_comment_replay_id
          : '',
        content: content,
      }).then((res) => {
        console.log('回复作品评论')
        console.log(res)
        if (res.is_create) {
          this.$message.success('回复成功')
          this.getScWorkCommentList()
        }
      })
    },

    //删除一级评论
    deleteScWorkComment(sc_work_comment_id) {
      deleteScWorkComment({
        sc_work_comment_id: sc_work_comment_id,
      }).then((res) => {
        console.log('删除作品一级评论')
        console.log(res)
        if (res.is_delete) {
          this.$message.success('删除成功')
          this.getScWorkCommentList()
        }
      })
    },
    //删除评论回复接口
    deleteScWorkCommentReplay(sc_work_comment_replay_id) {
      deleteScWorkCommentReplay({
        sc_work_comment_replay_id: sc_work_comment_replay_id,
      }).then((res) => {
        console.log('删除作品二级评论')
        console.log(res)
        if (res.is_delete) {
          this.$message.success('删除成功')
          this.getScWorkCommentList()
        }
      })
    },

    //查询作品评论接口
    getScWorkCommentList() {
      getScWorkCommentList({
        work_id: this.$route.query.work_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('查询作品评论')
        console.log(res)
        this.commentList = res.scWorkCommentList
        this.commentNum = res.total
        this.total1 = res.total
        let newList = []
        this.commentList.map((item) => {
          newList = item.replayList
          console.log(newList, 444444)
          newList.forEach((k) => {
            // console.log(k)
            console.log('from_name' in k, 36666)
            if ('from_name' in k === false) {
              k.from_name = ''
              console.log(k, 555)
            }
          })
        })
      })
    },

    //评论翻页
    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getScWorkCommentList()
    },

    //跳转到作品详情页面
    LookWork(item) {
      console.log('跳转到作品详情页面')
      console.log(item)
      window.location.href =
        '/community/project?work_id=' + item.id + '&subject_code=2'
    },

    //查看源码
    LookCode() {
      console.log('跳转到作品源码页面')
      console.log(this.workinfo.user_code)
      console.log(this.$store.state.user.userInfo.code)

      if (this.workinfo.user_code == this.$store.state.user.userInfo.code) {
        console.log('作者自己的作品')
        window.location.href =
          '/scratch/index.html?work_type=1&work_id=' +
          this.workinfo.id +
          '&subject_code=2&operate=edit'
      } else {
        window.location.href =
          '/scratch/index.html?work_type=1&work_id=' +
          this.workinfo.id +
          '&subject_code=2'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  // margin-top: 20px;
  min-height: 600px;
  padding-top: 20px;
  background: #f9f9f9;

  .work_img_wrapper {
    background-image: url(https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/homepage/loading-web.gif);
    background-size: 50%;
    background-position: center;
    background-repeat: no-repeat;

    position: relative;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 100%;
    height: 0;
    padding-bottom: 85%;

    box-sizing: border-box;

    .work_img {
      width: 100%;
    }
  }

  .workactive {
    padding: 10px 0 20px;
    text-align: center;
    background: white;

    .work_thumb_div {
      display: flex;

      align-items: center;
      height: 100%;
      line-height: 25px;

      .work_thumb_txt {
        font-size: 14px;
        color: #333333;
        font-weight: bold;
        margin-right: 5px;
      }

      .work_thumb_num {
        font-size: 12px;
        color: #999999;
      }
    }

    .workshare {
      margin-top: 5%;
    }

    .worklook {
      margin-top: 5%;
    }
  }

  .tools {
    text-align: right;
    background: white;
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    padding-right: 5px;
  }

  .createrinfo {
    height: 150px;

    .createrinfo-left {
      display: flex;
      flex-flow: column;
      height: 150px;

      text-align: center;

      .createrinfo-left-img {
        width: 80px;
        height: 80px;
        border-radius: 20px;

        background: white;
        margin-top: 35px;
        margin-left: 35px;

        .left-img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }
      }
    }

    .createrinfo-right {
      display: flex;
      flex-flow: column;
      height: 150px;

      text-align: left;

      .right-name {
        margin-top: 50px;
        font-size: 18px;
        font-weight: bold;
      }

      .right-num {
      }

      .right-add {
      }
    }
  }

  .worktitle {
    padding-left: 10px;
    padding-bottom: 10px;
    padding-top: 10px;
    font-size: 16px;
  }

  .worklooknum {
    padding-left: 10px;
    padding-bottom: 10px;
  }

  .worktag {
    padding-bottom: 10px;

    .type {
      margin-left: 10px;
    }
  }

  .workcode {
    padding-right: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    text-align: left;
  }

  .wordintro {
    padding-left: 10px;
    padding-bottom: 10px;
  }

  .intro_content {
    padding-left: 15px;
    padding-bottom: 15px;
  }

  .morework_wrapper {
    margin-top: 20px;
    margin-bottom: 40px;

    .morework {
      margin-top: 10px;
      padding: 10px;
      font-size: 16px;
      font-weight: 500;
    }

    .workmore_left {
      padding: 20px;

      .workmore_img_wrapper {
        position: relative;
        top: 0;
        left: 0;
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-bottom: 75%;
        box-sizing: border-box;
        border: 1px solid rgb(240, 237, 232);
        border-radius: 5px;

        .workmore_img {
          cursor: pointer;
          width: 100%;
          border-radius: 5px;
        }
      }
    }

    .workmore_right {
      .workmore_right_title {
        margin-top: 25%;
        font-size: 16px;
      }

      .workmore_right_num {
        line-height: 20px;
      }
    }
  }

  .comment {
    margin-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
